import { render, staticRenderFns } from "./Bilanz.vue?vue&type=template&id=1347cca1&"
import script from "./Bilanz.vue?vue&type=script&lang=ts&"
export * from "./Bilanz.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports